import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * used only in history carrier tab
 */
@Component({
  selector: 'fr8bot-business-tab-title',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './business-tab-title.component.html',
  styleUrl: './business-tab-title.component.scss',
  imports: [],
})
export class BusinessTabTitleComponent {}
